module.exports = __webpack_public_path__ + "static/media/stretch.3299c213.svg";